var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages-pay-authorize"},[_vm._v(" 加载中... ")])}
var staticRenderFns = []

export { render, staticRenderFns }